export var isDoubleBooking = function isDoubleBooking(paidBookings, moveIn, moveOut) {
  if (!(paidBookings !== null && paidBookings !== void 0 && paidBookings.length) || !moveIn || !moveOut) {
    return false;
  }
  var formattedMoveIn = new Date(moveIn);
  var formattedMoveOut = new Date(moveOut);
  return paidBookings.some(function (booking) {
    var bookingMoveIn = new Date(booking.moveInOut.start);
    var bookingMoveOut = new Date(booking.moveInOut.end);
    return formattedMoveIn >= bookingMoveIn && formattedMoveIn <= bookingMoveOut || formattedMoveOut >= bookingMoveIn && formattedMoveOut <= bookingMoveOut || formattedMoveIn <= bookingMoveIn && formattedMoveOut >= bookingMoveOut;
  });
};